export const SearchTypeVisual = 27 as const;
export type TSearchTypeVisual = typeof SearchTypeVisual;

export enum VisualType {
	ASSET = 1,
	COLOR = 2,
}
